"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var react_redux_1 = require("react-redux");
var NeutralToggleButton_1 = __importDefault(require("atomicComponents/molecules/ToggleButton/NeutralToggleButton"));
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var TaxTypeButton = function (_a) {
    var _b, _c;
    var item = _a.item;
    var _d = __read((0, hooks_1.useSubmitter)('recharged_customers', item.id, {
        isTaxExcluded: !item.isTaxExcluded, isTaxExcludedSetManually: true,
    }), 2), toggleTax = _d[0], isSetting = _d[1];
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var taxName = rechargerCompany ? ((_c = (_b = (0, end2end_1.getTaxRateObj)(rechargerCompany, item)) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : 'GST') : undefined;
    return ((0, jsx_runtime_1.jsx)(NeutralToggleButton_1.default, __assign({ disabled: isSetting, selected: !item.isTaxExcluded, value: "check", onChange: function (e) {
            e.stopPropagation();
            toggleTax();
        } }, { children: item.isTaxExcluded ? 'Zero' : taxName })));
};
exports.default = TaxTypeButton;
